import classes from '../CarbonEmission.module.css';
import { timeOnly } from '../../../utils/dateHelper';
import EChart from '../../../components/Echarts/Echarts';
import DatePicker from '../../../components/Inputs/DatePicker/DatePicker';
import { usToEuCurrencyFormat } from '../../../utils/currencyHelper';

const ChartContainer = ({ graphData, date, setDate, lastStatus }) => {
    return (
        <div className={classes.BottomContainer}>
            <EChart
                series={graphData}
                title="Carbon Emission"
                xFormatter={timeOnly}
                yFormatter={(v) => usToEuCurrencyFormat(parseFloat(v).toFixed(0))}
                type="line"
                step
                lastReported={lastStatus}
                rightSideElement={
                    <div>
                        <DatePicker date={date} setDate={setDate} />
                    </div>
                }
                yTooltipSuffix={['kWh', 'kWh']}
            />
        </div>
    );
};

export default ChartContainer;
